import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import EliteFitnessPerformance from "./sections/EliteFitnessPerformance";
import RecentChronicles from "./sections/RecentChronicles";
import TravelersJournal from "./sections/TravelersJournal";
import OurSignatureSolutions from "./sections/OurSignatureSolutions";
import WhyChooseUs from "./sections/WhyChooseUs";
import JoinTheCommunity from "./sections/JoinTheCommunity";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <EliteFitnessPerformance />
      <RecentChronicles />
      <TravelersJournal />
      <OurSignatureSolutions />
      <WhyChooseUs />
      <JoinTheCommunity />
      <Footer />
    </div>;
}